import axios from 'axios';

export const createEventService = async (formData) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/event/create`, formData)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const updateEventService = async (formData) => {
    try {
        return await axios.put(`${process.env.REACT_APP_API_URL}/api/event/update`, formData)
        .then((response)=>{
            return {success: true, data: response?.data, message: 'update_success'}
        }).catch((error)=>{
            console.log(error)
            return {success: false, data: null, message: error.response.data.message || 'generic_server_error_message'}
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listEventsByCreatedByService = async (created_by) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/event/list_by_created_by/${created_by}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listEventsByPlaceAccessKeyService = async (place_access_key,user_access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/event/list_by_place_access_key/${place_access_key}/${user_access_key}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const deleteEventService = async (access_key) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_API_URL}/api/event/delete/${access_key}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const getEventByAccessKeyService = async (access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/event/get_by_access_key/${access_key}`)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const goingEventService = async (user_access_key, event_access_key) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user_event/create`,{user_access_key, event_access_key})
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const notGoingEventService = async (id) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_API_URL}/api/user_event/delete/`+id)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listGoingEventsService = async (user_access_key, page, start_date, end_date) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user_event/list_by_user_access_key/`,{user_access_key, page, start_date, end_date})
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}

export const listPlaceEventsService = async (access_key, page) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/user_event/list_place_events/`+access_key+'/'+page)
        .then((response)=>{
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return false
        })
    } catch (error) {
            return 'generic_server_error_message'
    }
}
